const getters = {
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    user_nickname: state => state.user.user_nickname,
    user_id: state => state.user.user_id,
    userInfo: state => state.user.userInfo
  }
  export default getters
  


// WEBPACK FOOTER //
// ./src/store/getters.js